// Thin wrapper around the Meta Pixel (fbq). Safe no-op if fbq is unavailable.
export const fbTrack = (event, params = {}) => {
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", event, params);
    }
  } catch (e) {
    // swallow — tracking should never break the UI
  }
};
